import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment from "moment";
import apiPath from "../constants/apiPath";
import {
  ExclamationCircleOutlined,
  FilterFilled,
  UploadOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../context/AuthContext";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";

import { Select } from "antd";
const { Option } = Select;

const { RangePicker } = DatePicker;

const Search = Input.Search;
let baseURL = "/admin/certification";

function CertificateMangement({ type }) {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [image, setImage] = useState(null);
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp", "application/pdf",
    "application/msword",              // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

  const columns = [
    {
      title: "Certificate Type",
      render: (_, { sr_number }) => {
        return <div>{sr_number}</div>;
      },
    },
    {
      title: "Certificate",
      render: (_, { certificate }) => {
        if (!certificate?.url) return "No Certificate";

        const isImage = certificate?.type?.startsWith("image/");

        return isImage ? (
          <Image
            src={certificate.url}
            style={{ width: "50px", height: "50px", borderRadius: "5px", objectFit: "cover" }}
            alt="Certificate"
          />
        ) : (
          <Tag color="blue">
            <a
              href={certificate.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1890ff" }}
            >
              View Document
            </a>
          </ Tag>
        );
      }
    },
    {
      title: "Registration date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              <Button
                title="Edit"
                onClick={() => {
                  record?.image && setFile([record.image]);

                  console.log(record, "record>>>>>>>>>>>>>>>>>>>>>>>");
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i class="fa fa-light fa-pen"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(certificateCP.certifications); // assume this is the URL
    }
  }, [certificateModalVisible, certificateCP]);
  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleCertificationSubmit = (values) => {
    const payload = { image: image };

    request({
      url: `${baseURL}/certifications/${values}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Certification submitted successfully!", Severty.SUCCESS);
        fetchData(pagination); // Refresh the data after submission
      },

    });

    setImage(null); // Reset image after submission
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Certificates"
              extra={
                <>
                  <Button
                    onClick={(e) => {
                      setVisible(true);
                      setSearchText("");
                    }}
                  >
                    Add Certificate
                  </Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      {certificateModalVisible && (
        <Modal
          open={certificateModalVisible}
          title={certificateCP.certifications ? "Edit CP Certificate" : "Create CP Certificate"}
          onCancel={() => setCertificateModalVisible(false)}
          footer={null}
        >


          {/* Certificate form goes here */}
          <p>
            Certificate management for: <b>{certificateCP?.name || certificateCP?.userName}</b>
          </p>


          <SingleImageUpload
            value={image}
            fileType={FileType}
            imageType={"Profile"}
            btnName={" Logo"}
            onChange={(data) => handleImage(data)}
            isDimension={false}
          />

          <p className="img-size-details">
            ** Certificate should be in (.png, .jpeg, .jpg .pdf ) format and up to 5 MB **
          </p>

          {image && (
            <div className="mt-2 add-img-product mb-4">
              {image.endsWith(".pdf") ? (
                <a href={image} target="_blank" rel="noopener noreferrer">
                  View PDF
                </a>
              ) : (
                <Image width={120} src={image} />
              )}
            </div>
          )}

          <Button onClick={() => {
            // Handle certificate submission logic here

            handleCertificationSubmit(certificateCP?._id);
            setCertificateModalVisible(false);
          }}>
            Submit
          </Button>
          {/* You can add a form here for certificate details, upload, etc. */}
          {/* On submit, call your API to create/edit certificate */}
        </Modal>
      )}
    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [signature, setSignature] = useState(null);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ];

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
    form.setFieldValue("image", url);
  };

  const handleSignature = (data) => {
    setSignature(data);
    form.setFieldValue("signature", data); // ensure form sees update
  };

  // Populate form for edit
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        profileImage: data?.image,
        signature: data?.signature,
      });
      setImage(data?.image || null);
      setSignature(data?.certificate || null);
    }
  }, [data]);

  const onCreate = (values) => {
    const payload = {
      ...values,
      certificate: signature?.[0]
    };

    request({
      url: data
        ? `${baseURL}/edit-user/${data._id}`
        : `${baseURL}/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast(res.message, Severty.SUCCESS);
        hide();
        refresh();
      },
      onError: (err) => {
        ShowToast(err.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      width={500}
      title={data ? "Edit Certificate Template" : "Add Certificate Template"}
      okButtonProps={{ form: "add-mf-form", htmlType: "submit", loading }}
    >
      <Form id="add-mf-form" layout="vertical" form={form} onFinish={onCreate}>
        <Row gutter={16}>
          {/* Full Name */}
          <Col span={24} md={24}>
            <Form.Item
              label="Certificate Type"
              name="sr_number"
              rules={[
                { required: true, message: "Certificate number is required" },
                {
                  pattern: /^[A-Za-z0-9 \-]+$/,
                  message: "Only letters, numbers, spaces, and hyphen (-) are allowed",
                },
                {
                  max: 200,
                  message: "Certificate number should not exceed 20 characters",
                },
              ]}
            >
              <Input placeholder="Enter certificate serial number (e.g., MF2025A01)" />
            </Form.Item>
          </Col>
          <Col span={24} md={24}>
            <Form.Item
              label="Upload Certificate (Image or Document)"
              name="certificateFile"
            >
              <SingleImageUpload
                value={signature}
                fileType={FileType}
                imageType={"Certificate"}
                btnName={"Certificate"}
                onChange={(data) => handleSignature(data)}
                isDimension={false}
              />
            </Form.Item>

            {signature && (
              <div className="mt-2 mb-4">
                {signature?.type?.startsWith("image/") ? (
                  <Image width={120} src={signature.url} />
                ) : (
                  <a href={signature.url} target="_blank" rel="noopener noreferrer">
                    View Uploaded Certificate
                  </a>
                )}
              </div>
            )}
          </Col>


          {/* Signature Upload */}

        </Row>
      </Form>
    </Modal>

  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Title cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CertificateMangement;
